import { resolve } from "inversify-react";
import * as React from "react";
import DocumentMeta from "react-document-meta";
import { connect } from "react-redux";
import Fade from "react-reveal/Fade";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { actions as homeActions } from "../../actions/home.actions";
import { actions as mainActions } from "../../actions/main.actions";
import Button from "../../core/ui/button";
import Collapse from "../../core/ui/collapse";
import ContactPreview from "../../core/ui/contact-preview";
import ImageField from "../../core/ui/data-component/data-image";
import RaritySelect from "../../core/ui/data-component/rarity-select";
import Divider from "../../core/ui/divider";
import Form from "../../core/ui/form";
import Grid, { Col } from "../../core/ui/grid";
import FormInput from "../../core/ui/input";
import Modal from "../../core/ui/modal";
import NavNotifier from "../../core/ui/nav-notifier";
import Player from "../../core/ui/player";
import ScrollTop from "../../core/ui/scroll-top";
import TextArea from "../../core/ui/textarea";
import HttpService from "../../services/http.service";
import IdentityService from "../../services/identity.service";
import NumberProviderService from "../../services/number_provider";
import ToastService from "../../services/toast.service";
import ArtsDataService from "./arts.data.service";
import ArtHeader from "./parts/art-header";
import ProcessDetailImage from "./process-detail";
import PriceModal from "./parts/art-price-modal";
import PaymentComponent from "src/core/ui/payment-component";
import Container from "../../core/ui/container";
import images from "src/assets/images";
import { IApplicationState, IArtModule, Identity, IDetailedArt } from "../../typings";
import EditionTypeSelect from "../../core/ui/data-component/edition-type-select";
import EditionNumberSelect from "../../core/ui/data-component/edition-number-select";
import {ArtworkDto, ArtworkService, EditionDto} from "../../services/openapi/generated";
import QRCode from "react-qr-code";

export interface ArtDetailProps extends RouteComponentProps<{ id: string }> {
    identity: Identity;
    getNext: (model: IDetailedArt) => void;
    getPrevious: (model: IDetailedArt) => void;

    getNextArttoken?: (model: IDetailedArt) => number;
    getPreviousArttoken?: (model: IDetailedArt) => number;
}

export interface ArtDetailState {
    detail?: IDetailedArt;
    height?: number;
    contactModal: boolean;
    sendModal: boolean;
    cloneModal: boolean;
    priceModal: boolean;
    buyModal: boolean;
    image?: string;
    password: string;
    secondPassword: string;
    address: string;
    price: string | undefined;
    loadingDuplicate: boolean;
    maxNumberOfEditions: number;

    // contactModalValues
    text?: string;
    fullName?: string;
    email?: string;
    emailReceiver?: string;
    edition?: string;
    emailErrors?: string[];
    textErrors?: string[];
    fullNameErrors?: string[];
    loading: boolean;
    loadingPage: boolean;
    // cloneModalValues
    publicEditionNumber: string;
    editionType: string;
    uid: string;
    tah: string;
    selectedEdition: number | null;
    artwork: ArtworkDto | undefined;
}

export class PropertyText extends React.Component<{ title: string; value: any; copy?: boolean; qr?: boolean }, any> {
    public state = {
        qrModal: false,
    };

    public onClick() {
        (navigator as any).clipboard.writeText(this.props.value);
    }

    public render() {
        const maxWidth = 250 - (!!this.props.copy ? 32 : 0) - (!!this.props.qr && this.props.value.length < 2500 ? 32 : 0);

        return (
            <div className="art-property">
                <Fade right={true}>
                    <h4 className="property-title">{this.props.title}</h4>
                    <h4 className="property-value" style={{ maxWidth, maxHeight: 22 }}>{this.props.value}</h4>
                </Fade>
                {!!this.props.copy && <img style={{ marginLeft: 10, width: 22, cursor: "pointer" }} src={images.copy} alt="" onClick={() => this.onClick()}/>}
                {!!this.props.qr && this.props.value.length < 2500 && <img style={{ marginLeft: 10, width: 22, cursor: "pointer" }} src={images.qr} alt="" onClick={() => this.setState({ qrModal: true })}/>}
                <Modal
                    closable={true}
                    type="dark"
                    size="complete"
                    closeOnDimmer={true}
                    className="fixed"
                    onCancel={() => this.setState({ qrModal: false })}
                    visible={this.state.qrModal}
                >
                    <div className="contact-artist-form">
                        <Grid centered={true}>
                            <Col size={50}>
                                <div className="login-form">
                                    <p className="not-mobile">
                                        {/*this.state.generalErrors && this.state.generalErrors.map((item, index) => item)*/}
                                    </p>
                                    <QRCode value={this.props.value} size={256} bgColor="#282c34" fgColor="#fff" level="L" />
                                </div>
                            </Col>
                        </Grid>
                    </div>
                </Modal>
            </div>
        );
    }
}

export class ArtDetail extends React.Component<ArtDetailProps & typeof homeActions & typeof mainActions, ArtDetailState> {
    @resolve
    public dataService: ArtsDataService;

    @resolve
    public editionService: NumberProviderService;

    @resolve
    public httpService: HttpService;

    @resolve
    public identityService: IdentityService;

    @resolve
    public toasts: ToastService;

    constructor(props: any) {
        super(props);

        this.state = {
            address: "",
            loadingPage: true,
            maxNumberOfEditions: 3,
            contactModal: false,
            cloneModal: false,
            email: "",
            edition: "",
            fullName: "",
            publicEditionNumber: "0",
            editionType: "",
            uid: "",
            tah: "",
            loading: false,
            loadingDuplicate: false,
            password: "",
            secondPassword: "",
            sendModal: false,
            priceModal: false,
            buyModal: false,
            price: undefined,
            selectedEdition: null,
            artwork: undefined,
        };
    }

    public componentWillReceiveProps(nextProps: ArtDetailProps) {
        if (nextProps.identity !== this.props.identity) {
            if (nextProps.identity.userInfo !== this.props.identity.userInfo && !!nextProps.identity.userInfo) {
                this.setState({
                    email: nextProps.identity.isAuthenticated && !!nextProps.identity.userInfo ? nextProps.identity.userInfo.email : "",
                    fullName:
                        nextProps.identity.isAuthenticated && !!nextProps.identity.userInfo ? nextProps.identity.userInfo.full_name : "",
                });
            }
        }
    }

    public refreshArtwork() {
        return ArtworkService.artworkControllerGetArtworkDetails(Number(this.props.match.params.id)).then((artwork) => {
            this.setState({
                artwork,
                selectedEdition: artwork.editions.length > 0 ? 0 : null,
                price: Math.random().toString(),
            });
        }).catch((e) => console.log(e));
    }

    public componentDidMount() {
        this.props.changeLocation("art_detail");
        this.refreshArtwork().then(() => {
            this.setState({
                loadingPage: false,
            });
        });
        this.setState({
            email: this.props.identity.isAuthenticated && !!this.props.identity.userInfo ? this.props.identity.userInfo.email : "",
            fullName: this.props.identity.isAuthenticated && !!this.props.identity.userInfo ? this.props.identity.userInfo.full_name : "",
        });
    }

    public getContactModalContent = () => {
        if (!this.state.detail) {
            return null;
        }
        return (
            <div className="contact-artist-form">
                <Grid centered={true}>
                    <Col size={50}>
                        <Form onSubmit={this.contact}>
                            <div className="login-form">
                                <p className="not-mobile">
                                    {/*this.state.generalErrors && this.state.generalErrors.map((item, index) => item)*/}
                                </p>
                                <FormInput
                                    className="not-mobile"
                                    noInput={true}
                                    extraContent={[<h2 className="contact-form-header">Send message to artist</h2>]}
                                />

                                <h2 className="contact-form-header mobile">Send message to artist</h2>
                                <FormInput
                                    style="light"
                                    label="Your Full name"
                                    placeholder="Enter your full name"
                                    value={this.state.fullName}
                                    errors={this.state.fullNameErrors}
                                    // disabled={this.props.identity.isAuthenticated}
                                    onChange={(e) => this.setState({ fullName: e })}
                                />

                                <FormInput
                                    style="light"
                                    label="Your Email"
                                    value={this.state.email}
                                    errors={this.state.emailErrors}
                                    placeholder="Email"
                                    onChange={(e) => this.setState({ email: e })}
                                    extraContent={[
                                        <div className="contact-form-footer">
                                            <ContactPreview
                                                description={`${this.state.detail.title} ${this.state.detail.medium} ${this.state.detail.dimensions} `}
                                                imageId={this.state.detail.image as string}
                                            />
                                            <TextArea
                                                placeholder="Hi, I’m interested in purchasing this work. Could you please provide more information about the piece?"
                                                type="dark"
                                                errors={this.state.textErrors}
                                                value={this.state.text}
                                                onChange={(e) => this.setState({ text: e })}
                                            />
                                            <Button disabled={this.state.loading} presentation="dark" className="login-btn" as={<button />}>
                                                SEND
                                            </Button>
                                        </div>,
                                    ]}
                                />
                            </div>
                        </Form>
                    </Col>
                </Grid>
            </div>
        );
    }

    public getCloneModal = (id: number) => {
        const { artwork } = this.state;
        if (!artwork) {
            return null;
        }
        return (
            <div className="duplicate-artwork">
                <Grid centered={true}>
                    <Col size={50}>
                        <Form onSubmit={() => this.clone(artwork.id)}>
                            <h2 className="contact-form-header">Duplicate Artwork</h2>
                            Are you sure you want to duplicate your artwork?
                            <ContactPreview
                                description={`${artwork.name} ${artwork.medium} ${artwork.dimensions} `}
                                imageId={artwork.image as string}
                            />
                            <EditionTypeSelect
                                placeholder="Select category"
                                label="Choose category"
                                type="light"
                                value={this.state.editionType}
                                onChange={(e) => this.setState({ editionType: e.id })}
                            />
                            {this.state.editionType === "limited-edition" && (
                                <FormInput
                                    style="light"
                                    label="Edition Number"
                                    placeholder="Edition Number"
                                    value={this.state.publicEditionNumber}
                                    onChange={(e) => this.setState({ publicEditionNumber: e })}
                                />
                            )}
                            <FormInput
                                style="light"
                                label="TAG"
                                placeholder="TAG"
                                value={this.state.tah}
                                onChange={(e) => this.setState({ tah: e })}
                            />
                            {!this.state.loadingDuplicate && (
                                <Button presentation="dark" className="duplicate-btn" as={<button />}>
                                    {this.state.loadingDuplicate ? (
                                        <img src={images.loadingWhite} className="loading-icon fa-spin big-spinner" />
                                    ) : (
                                        "Confirm"
                                    )}
                                </Button>
                            )}
                        </Form>
                    </Col>
                </Grid>
            </div>
        );
    }

    public clone = (id: number) => {
        this.setState({
            loadingDuplicate: true,
        });
        const publicEditionNumber = this.state.publicEditionNumber;
        const type = this.state.editionType;
        const uid = this.state.uid;
        const tah = this.state.tah;

        this.dataService
            .cloneToken(id, type, uid, tah, Number(publicEditionNumber))
            .then((result) => {
                this.setState({
                    cloneModal: false,
                    loadingDuplicate: false,
                });
                this.toasts.showToast("Clone artwork", "Artwork duplicated succesfully", "success");
                this.refreshArtwork();
            })
            .catch((error) => {
                this.setState({
                    loadingDuplicate: false,
                });
                this.toasts.showToast("Clone artwork", "Edition already created or not enough credits", "error");
            });
    }

    public getSendModalContent = () => {
        const { artwork, selectedEdition } = this.state;
        if (!artwork) {
            return null;
        }
        const edition = selectedEdition !== null ? artwork.editions[selectedEdition] : null;
        if (!edition) {
            return null;
        }
        return (
            <div className="contact-artist-form">
                <Grid centered={true}>
                    <Col size={50}>
                        <Form onSubmit={this.send} disabled={this.state.loading}>
                            <div className="login-form">
                                <p className="not-mobile">
                                    {/*this.state.generalErrors && this.state.generalErrors.map((item, index) => item)*/}
                                </p>
                                <FormInput
                                    className="not-mobile"
                                    noInput={true}
                                    extraContent={[<h2 className="contact-form-header">Transfer Artwork</h2>]}
                                />
                                <h2 className="contact-form-header mobile">Transfer Artwork</h2>
                                <FormInput
                                    style="light"
                                    label="Art edition"
                                    value={this.formatEditionName(edition)}
                                    disabled={true}
                                />
                                <FormInput
                                    style="light"
                                    label="Receiver user"
                                    placeholder="Email or address"
                                    value={this.state.address}
                                    onChange={(e) => this.setState({ address: e })}
                                />
                                <FormInput
                                    style="light"
                                    label="Password"
                                    type="password"
                                    placeholder="Password"
                                    value={this.state.password}
                                    onChange={(e) => this.setState({ password: e })}
                                />
                                <Button disabled={this.state.loading} presentation="dark" className="login-btn" as={<button />}>
                                    {this.state.loading ? (
                                        <img src={images.loadingWhite} className="loading-icon fa-spin big-spinner" />
                                    ) : (
                                        "SEND"
                                    )}
                                </Button>
                            </div>
                        </Form>
                    </Col>
                </Grid>
            </div>
        );
    }

    public renderProcess = () => {
        const { artwork } = this.state;
        if (!artwork || !artwork.process_module || !artwork.process_module.visible) {
            return null;
        }
        if (!this.canViewInner(artwork.process_module)) {
            return null;
        }
        const ins = artwork.process_module;
        return (
            <Collapse overrideToggle={this.handleIsAuthenticatetoOpen} title="Process">
                <Fade bottom={true}>
                    <p className="description">{artwork.process_module.description}</p>
                </Fade>
                {ins.video_link && (
                    <Fade right={true}>
                        <Player className="process-video" url={ins.video_link} />
                    </Fade>
                )}
                <div className="process-container process-container1">
                    {ins.image1 !== undefined && <ProcessDetailImage id={ins.image1 as string} title={ins.title1} />}
                    {ins.image2 !== undefined && <ProcessDetailImage id={ins.image2 as string} title={ins.title2} />}
                    {ins.image3 !== undefined && <ProcessDetailImage id={ins.image3 as string} title={ins.title3} />}
                </div>
                <Fade bottom={true}>{ins.quote && <p className="quote">"{ins.quote}"</p>}</Fade>
                <div className="process-container process-container2">
                    {ins.image4 !== undefined && <ProcessDetailImage id={ins.image4 as string} title={ins.title4} />}
                    {ins.image5 !== undefined && <ProcessDetailImage id={ins.image5 as string} title={ins.title5} />}
                    {ins.image6 !== undefined && <ProcessDetailImage id={ins.image6 as string} title={ins.title6} />}
                </div>
            </Collapse>
        );
    }

    public renderFinal = () => {
        const artwork = this.state.artwork;
        if (!artwork || !artwork.final_piece_module || !artwork.final_piece_module.visible) {
            return null;
        }
        if (!this.canViewInner(artwork.final_piece_module)) {
            return null;
        }

        return (
            <Collapse overrideToggle={this.handleIsAuthenticatetoOpen} noleftMargin={true} title="Final piece">
                <Fade bottom={true}>
                    <p className="description final">{artwork.final_piece_module.description}</p>
                </Fade>
                <div className="process-column-container">
                    <div id="full-width-images" className="process-final-images">
                        <ImageField id={artwork.final_piece_module.image1 as string} />
                        <ImageField id={artwork.final_piece_module.image2 as string} />
                        <ImageField id={artwork.final_piece_module.image3 as string} />
                    </div>
                </div>
            </Collapse>
        );
    }

    public canViewInner = (mod?: IArtModule) => {
        return !!this.state.artwork;
    }

    public handleIsAuthenticatetoOpen = (collapsed: boolean) => {
        if (!this.identityService.isAuthenticated()) {
            this.props.toggleLogin(true, 0);
            return true;
        }

        return !collapsed;
    }
    public renderInspiration = () => {
        const { artwork } = this.state;
        if (!artwork || !artwork.inspiration_module || !artwork.inspiration_module.visible) {
            return null;
        }
        if (!this.canViewInner(artwork.inspiration_module)) {
            return null;
        }
        const ins = artwork.inspiration_module;
        return (
            <Collapse overrideToggle={this.handleIsAuthenticatetoOpen} title="Inspiration">
                <Fade bottom={true}>
                    <p className="description">{artwork.inspiration_module.description}</p>
                </Fade>
                <div className="process-container process-container1">
                    {ins.image1 !== undefined && <ProcessDetailImage id={ins.image1 as string} title={ins.title1} />}
                    {ins.image2 !== undefined && <ProcessDetailImage id={ins.image2 as string} title={ins.title2} />}
                    {ins.image3 !== undefined && <ProcessDetailImage id={ins.image3 as string} title={ins.title3} />}
                </div>
                <Fade right={true}>{artwork.inspiration_module.quote && <p className="quote">"{artwork.inspiration_module.quote}"</p>}</Fade>
                <div className="process-container process-container2">
                    {ins.image4 !== undefined && <ProcessDetailImage id={ins.image4 as string} title={ins.title4} />}
                    {ins.image5 !== undefined && <ProcessDetailImage id={ins.image5 as string} title={ins.title5} />}
                    {ins.image6 !== undefined && <ProcessDetailImage id={ins.image6 as string} title={ins.title6} />}
                </div>
            </Collapse>
        );
    }

    public contact = () => {
        if (!!this.state.detail && !this.state.loading) {
            this.setState({ loading: true });
            this.dataService
                .contactArtist(this.state.fullName, this.state.email, this.state.detail.id, this.state.text)
                .then((result) => {
                    // console.log("got result", result);
                    this.setState({
                        text: "",
                        contactModal: false,
                        emailErrors: undefined,
                        textErrors: undefined,
                        fullNameErrors: undefined,
                        loading: false,
                    });
                    this.toasts.showToast("Contact artist", "You will receive a feedback from the artist directly very soon", "success");
                })
                .catch((error) => {
                    this.toasts.showToast(
                        "Contact artist",
                        "Oops, something went wrong " + error.text
                            ? "Text: " + error.text.join(";")
                            : "" + error.email
                            ? "Email: " + error.email.join(";")
                            : "",
                        "error",
                    );

                    this.setState({
                        emailErrors: error.email,
                        fullNameErrors: error.full_name,
                        loading: false,
                        textErrors: error.text,
                    });
                });
        }
    }

    public send = () => {
        const { artwork, selectedEdition } = this.state;
        if (!artwork) {
            return null;
        }
        const edition = selectedEdition !== null ? artwork.editions[selectedEdition] : null;
        if (!edition) {
            return null;
        }
        if (!!edition && !this.state.loading) {
            this.setState({ loading: true });

            this.dataService
                .sendToken(artwork.id, edition.id, this.state.address, this.state.password)
                .then((result) => {
                    this.setState({
                        loading: false,
                        sendModal: false,
                    });
                    this.toasts.showToast("Transfer artwork", "Art sent succesfully", "success");
                    this.props.history.goBack();
                })
                .catch((error) => {
                    this.setState({
                        loading: false,
                    });
                    this.toasts.showToast(
                        "Transfer artwork",
                        "Oops, something went wrong " + error.text
                            ? "Text: " + error.text.join(";")
                            : "" + error.email
                            ? "Email: " + error.email.join(";")
                            : "",
                        "error",
                    );
                });
        }
    }

    public canEdit = () => {
        const detail = this.state.detail;
        if (detail && detail.isCopy) {
            return false;
        }
        if (!this.identityService.isVerified) {
            return false;
        }
        const isOwner =
            this.identityService.userInfo && detail
                ? this.identityService.userInfo.wallet_address === detail.artist_wallet &&
                  this.identityService.userInfo.wallet_address === detail.owner_wallet
                : false;
        const result = this.identityService.isAuthenticated() && (this.identityService.isAdmin || isOwner);
        // console.log(result);
        return result;
    }

    public canClone = () => {
        const detail = this.state.detail;
        if (!detail) {
            return false;
        }
        const isOwner =
            this.identityService.userInfo && detail
                ? this.identityService.userInfo.wallet_address === detail.artist_wallet &&
                  this.identityService.userInfo.wallet_address === detail.owner_wallet
                : false;
        const result = this.identityService.isAuthenticated() && (this.identityService.isAdmin || isOwner);
        return result && detail.bound <= detail.edition_count && this.identityService.isVerified && !detail.isCopy;
    }

    public getContactAllowed = () => {
        if (!this.props.identity.isAuthenticated) {
            return true;
        }
        if (this.props.identity.isAuthenticated) {
            if (this.props.identity.userInfo && this.state.detail) {
                // console.log(this.props.identity.userInfo.wallet_address, this.state.detail.owner_wallet);
                if (this.props.identity.userInfo.wallet_address === this.state.detail.owner_wallet) {
                    return false;
                }
            }
        }
        return true;
    }

    public canDelete = () => {
        const detail = this.state.detail;
        if (!detail) {
            return false;
        }
        const isOwner =
            this.identityService.userInfo && detail
                ? this.identityService.userInfo.wallet_address === detail.artist_wallet &&
                  this.identityService.userInfo.wallet_address === detail.owner_wallet
                : false;

        return isOwner;
    }

    public async setPrice(price: string) {
        const { detail } = this.state;
        this.dataService.setPrice(Number(price), detail ? detail.title : undefined);
        this.setState({ price, priceModal: false });
    }

    public formatEditionType(type: EditionDto.type): string {
        if (type === EditionDto.type.LIMITED_EDITION) return `Limited Edition`;
        else if (type === EditionDto.type.ARTIST_PROOF) return `Artist Proof`;
        else if (type === EditionDto.type.HORS_DU_COMMERCE) return `Hors du Commerce`;
        return "";
    }
    public formatEditionName(edition: EditionDto): string {
        return `${this.formatEditionType(edition.type)} ${edition.publicEditionNumber}`;
    }

    public async changeEdition(edition: any) {
        const { artwork } = this.state;
        this.setState({
            selectedEdition: artwork!.editions.findIndex((artEdition) => this.formatEditionName(artEdition) === (edition).id),
        });
    }

    public render() {
        const { loadingPage  } = this.state;
        const { artwork, selectedEdition } = this.state;
        if (!artwork && !loadingPage) {
            return (
                <Container>
                    <div className="page-404">
                        <h1>404 Page not found</h1>
                        <p>We apologize for the inconvenient, we are working to improve the service.</p>
                    </div>
                </Container>
            );
        }
        if (!artwork) { return <Container> </Container>; }

        const edition = selectedEdition !== null ? artwork.editions[selectedEdition] : null;

        let logged = false;
        if (this.state.email) {
            logged = true;
        }
        let send = false;
        if (edition !== null && this.identityService.userInfo && edition.ownerAddress!.toUpperCase() === this.identityService.userInfo.wallet_address.toUpperCase()) {
            send = true;
        }

        let isArtist = false;
        if (this.identityService.userInfo) {
            if (artwork.artistId === this.identityService.userInfo.id) {
                isArtist = true;
            }
        }

        const title = `Encrypto Art - ${artwork.name}`;
        const description = artwork.description_module ? artwork.description_module.description : "";
        const url = `${this.httpService.domainUrl}/arts/${artwork.id}`;
        const image = this.state.image;
        const meta = {
            canonical: url,
            description,
            title,
            meta: {
                property: {
                    // facebook
                    "og:type": "website",
                    "og:site_name": this.httpService.domainName,
                    "og:image": image,
                    "og:title": title,
                    "og:description": description,
                    "og:url": url,
                    // twitter
                    "twitter:description": description,
                    "twitter:url": url,
                    "twitter:title": title,
                    "twitter:card": "summary_large_image",
                    "twitter:site": "@Fineart",
                    "twitter:image": image,
                },
            },
        };

        const header = (
            <ArtHeader
                title={artwork.name}
                editionNumber={edition ? edition.publicEditionNumber : 0}
                editionCount={artwork.editions.length}
                canDelete={this.canDelete()}
                editionType={this.formatEditionType(edition ? edition.type : EditionDto.type.LIMITED_EDITION)}
                canClone={this.canClone()}
                canShare={true}
                canEdit={this.canEdit()}
                canFavourite={this.identityService.isAuthenticated() && this.getContactAllowed()}
                id={artwork.id}
                artistName={artwork.artistName}
            />
        );

        return (
            <DocumentMeta {...meta}>
                <Modal
                    closable={true}
                    type="dark"
                    size="complete"
                    closeOnDimmer={true}
                    className="fixed"
                    onCancel={() => this.setState({ contactModal: false })}
                    visible={this.state.contactModal}
                >
                    {this.getContactModalContent()}
                </Modal>
                <Modal
                    closable={true}
                    type="dark"
                    size="complete"
                    closeOnDimmer={true}
                    className="fixed"
                    onCancel={() => this.setState({ sendModal: false })}
                    visible={this.state.sendModal}
                >
                    {this.getSendModalContent()}
                </Modal>
                <Modal
                    closable={true}
                    type="dark"
                    size="complete"
                    closeOnDimmer={true}
                    className="fixed"
                    onCancel={() => this.setState({ cloneModal: false })}
                    visible={this.state.cloneModal}
                >
                    {this.getCloneModal(artwork.id)}
                </Modal>
                <PriceModal
                    visible={this.state.priceModal}
                    onCancel={() => this.setState({ priceModal: false })}
                    price={this.state.price}
                    onSetPrice={(price: string) => this.setPrice(price)}
                    title={artwork.name}
                />
                <Modal
                    className="payment-modal"
                    closable={true}
                    size="small"
                    visible={this.state.buyModal}
                    onCancel={() => this.setState({ buyModal: false })}
                >
                    <PaymentComponent
                        price={this.state.price}
                        title={"Buy " + artwork.name + " edition"}
                        onCompleted={() => undefined}
                    />
                </Modal>
                <ScrollTop>
                    <NavNotifier idk="light">
                        <div className="art-detail">
                            <Grid centered={true}>
                                <Col className="mobile menu" size={1}>
                                    <Fade right={true}>
                                        <h2 className="art-title">{artwork.name}</h2>
                                        {header}
                                    </Fade>
                                </Col>
                                <Col className="art-img1" size={30}>
                                    <Fade left={true}>
                                        <ImageField
                                            noImage={true}
                                            onLoad={(u) => this.setState({ image: u })}
                                            id={artwork.image as string}
                                        />
                                    </Fade>
                                    <div className="mobile art-navigation">
                                        {/*
                                            <Button
                                                className={detail.previous ? "" : "disabled"}
                                                presentation="blueprint"
                                                icon="caret-left"
                                                onClick={this.props.getPrevious}
                                            ></Button>
                                        }
                                        {
                                            <Button
                                                className={detail.next ? "" : "disabled"}
                                                presentation="blueprint"
                                                icon="caret-right"
                                                onClick={this.props.getNext}
                                            ></Button>
                                        */}
                                    </div>
                                    <div className="detail-actions mobile">
                                        <ArtHeader
                                            title=""
                                            mobile={true}
                                            onlyActions={true}
                                            editionNumber={edition ? edition.publicEditionNumber : 0}
                                            editionCount={artwork.editions.length}
                                            canDelete={this.canDelete()}
                                            editionType={this.formatEditionType(edition ? edition.type : EditionDto.type.LIMITED_EDITION)}
                                            canClone={this.canClone()}
                                            canShare={true}
                                            canEdit={this.canEdit()}
                                            canFavourite={this.identityService.isAuthenticated() && this.getContactAllowed()}
                                            id={artwork.id}
                                        />
                                    </div>
                                </Col>
                                <Col size={4} />
                                <Col size={40}>
                                    <div className="art-common">
                                        <div className="not-mobile">{header}</div>
                                        <Fade left={true}>
                                            <h2 className="art-title not-mobile">{artwork.name}</h2>
                                        </Fade>
                                        <Grid centered={true}>
                                            <Col size={90}>
                                                {edition && (
                                                    <div className="art-properties">
                                                        <EditionNumberSelect
                                                            label={"Editions"}
                                                            value={this.formatEditionName(edition)}
                                                            values={artwork.editions.map((edition) => this.formatEditionName(edition))}
                                                            onChange={(e) => this.changeEdition(e)} />
                                                        <h4 className="edition-title">Edition Information</h4>
                                                        <PropertyText
                                                            title="Edition Number"
                                                            value={(edition.publicEditionNumber) + (edition.type === EditionDto.type.LIMITED_EDITION ? " / " + artwork.maxNumberOfEditions : "")}
                                                        />
                                                        {edition.tah && <PropertyText title="TAG" value={edition.tah} copy={true} qr={true} />}
                                                        {/*<PropertyText title="UID" value={edition.uid} />*/}
                                                        <PropertyText title="Edition Type" value={this.formatEditionType(edition.type)} />
                                                    </div>
                                                )}
                                                {selectedEdition == null && (
                                                    <div className="art-properties">
                                                        <h3 className="edition-title">Artwork has no editions</h3>
                                                    </div>
                                                )}
                                                <div className="art-properties">
                                                    <h2 className="edition-title">Artwork Information</h2>
                                                    <PropertyText title="Creation Year" value={new Date(artwork.creationDate).getFullYear()} />
                                                    <PropertyText title="Medium" value={artwork.medium} />
                                                    <PropertyText title="Dimensions" value={artwork.dimensions} />
                                                    <PropertyText
                                                        title="Category"
                                                        value={
                                                            <div>
                                                                <RaritySelect mode="display" value={artwork.rarity} />
                                                            </div>
                                                        }
                                                    />
                                                    <PropertyText title="Mold created in" value={artwork.location} />

                                                    {/* <PropertyText title='Ownership History' value={<History plain wallet_hash={detail.blockchain_hash} />} /> */}
                                                    {/*<PropertyText title="Location" value={detail.location} />*/}
                                                    {/* TODO: Price in specs?
                                                    <PropertyText
                                                        title="Price"
                                                        value={this.state.price ? this.state.price + " credits" : "Not set"}
                                                    />
                                                    */}
                                                    <div>
                                                        {false && !isArtist && logged && (
                                                            <>
                                                                <div className="art-property contact-container">
                                                                    <p className="art-contact-btn-desc not-mobile">
                                                                        Interested in this work? Contact the artist.
                                                                    </p>
                                                                    <Button
                                                                        onClick={() => this.setState({ contactModal: true })}
                                                                        className="button art-detail-contact-btn"
                                                                    >
                                                                        Contact artist
                                                                    </Button>
                                                                </div>
                                                            </>
                                                        )}
                                                        {send && logged && (
                                                            <div className="art-property contact-container">
                                                                <Button
                                                                    onClick={() => this.setState({ sendModal: true })}
                                                                    className="button art-detail-contact-btn"
                                                                >
                                                                    Send art
                                                                </Button>
                                                                <p className="art-contact-btn-desc not-mobile"></p>
                                                            </div>
                                                        )}
                                                        {isArtist && (
                                                            <>
                                                                <div className="art-property contact-container">
                                                                    <Button
                                                                        onClick={() => this.setState({ cloneModal: true })}
                                                                        className="button art-detail-contact-btn"
                                                                    >
                                                                        Create edition
                                                                    </Button>
                                                                    <p className="art-contact-btn-desc not-mobile"></p>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                {edition && <div className="art-properties">
                                                    <h2 className="edition-title">Blockchain Information</h2>
                                                    <a href={(window as any).SITE_CONFIG.explorerUrl + "/address/" + artwork.contractAddress} target="_blank" >
                                                        <PropertyText title="Contract address" value={artwork.contractAddress} copy={true} />
                                                    </a>
                                                    <PropertyText title="Token ID" value={edition.tokenId} copy={true} />
                                                </div>
                                                }
                                            </Col>
                                            <Col size={10}>
                                                <div className="art-navigation large not-mobile">
                                                    {/*
                                                        <Button
                                                            className={detail.previous ? "" : "disabled"}
                                                            presentation="blueprint"
                                                            icon="caret-left"
                                                            onClick={() => this.props.getPrevious(detail)}
                                                        ></Button>
                                                    }
                                                    {
                                                        <Button
                                                            className={detail.next ? "" : "disabled"}
                                                            presentation="blueprint"
                                                            icon="caret-right"
                                                            onClick={() => this.props.getNext(detail)}
                                                        ></Button>
                                                    */}
                                                </div>
                                            </Col>
                                        </Grid>
                                    </div>
                                </Col>
                            </Grid>
                            {artwork.description_module && artwork.description_module.description && (
                                <Grid className="description-container" centered={true}>
                                    <Col size={30} className="art-description">
                                        <Fade left={true}>
                                            <h3>DESCRIPTION</h3>
                                            <Divider />
                                        </Fade>
                                        <Fade bottom={true}>
                                            {artwork.description_module && (
                                                <div dangerouslySetInnerHTML={{ __html: artwork.description_module.description }}></div>
                                            )}
                                        </Fade>
                                    </Col>
                                    <Col size={40} className="art-description-img">
                                        <Fade bottom={true}>
                                            {artwork.description_module && <ImageField id={artwork.description_module.image as string} />}
                                        </Fade>
                                    </Col>
                                </Grid>
                            )}
                            <Grid centered={true}>
                                <Col size={100}>
                                    {this.renderInspiration()}
                                    {this.renderProcess()}
                                    {this.renderFinal()}
                                </Col>
                            </Grid>
                        </div>
                    </NavNotifier>
                </ScrollTop>
            </DocumentMeta>
        );
    }
}

function mapStateToProps(state: IApplicationState, ownProps) {
    return {
        ...ownProps,
        ...state.routing,
        identity: state.identity,
    };
}

export default connect(mapStateToProps, { ...homeActions, ...mainActions })(withRouter(ArtDetail));



// WEBPACK FOOTER //
// ./src/components/arts/art-detail.tsx